module.exports = __webpack_public_path__ + "static/media/TaskManagement_Ordinary_001.f58804e1.png";